import WalkthroughTipPresenter from "frontend/walkthrough-tips/walkthrough-tip-presenter";
import { useRef } from "react";
import { TipName } from "shared/datamodel/schemas";
import { FooterButtonGroup, FooterButton } from "../footer";

export function ExportButton({ onClick }: { onClick: () => void }) {
  const buttonRef = useRef<HTMLDivElement>(null);
  return (
    <FooterButtonGroup>
      <FooterButton tooltip="Export" onClick={onClick} ref={buttonRef} testid={"open-export-dialog-button"}>
        <svg height="20" viewBox="0 0 46 53" fill="none" stroke="#113255" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M25.5003 3V13C25.5003 13.663 25.7637 14.2989 26.2325 14.7678C26.7014 15.2366 27.3372 15.5 28.0003 15.5H38.0003"
            strokeWidth="4.19118"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.25 48H8C6.67392 48 5.40215 47.4732 4.46447 46.5355C3.52678 45.5979 3 44.3261 3 43V8C3 6.67392 3.52678 5.40215 4.46447 4.46447C5.40215 3.52678 6.67392 3 8 3H25.5L38 15.5V28M25.5 43H43M43 43L35.5 35.5M43 43L35.5 50.5"
            strokeWidth="4.19118"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </FooterButton>
      <WalkthroughTipPresenter tipName={TipName.walkthroughExportCanvas} attachToRef={buttonRef} />
    </FooterButtonGroup>
  );
}
